const modules = import.meta.glob<{ default: string }>('./jelence-*.jpg', { eager: true });

export const jelenceImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/jelence-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/jelence-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);
